export type VideoPlayerOptions = {
  autoplay: boolean
  muted: boolean
  aspectRatio: string
  responsive: boolean
  controls: boolean
  playback_rates: number[]
  skip_buttons: {
    forward: number
    backward: number
  }
}

export const FULL_VIDEO_VIEW_HEIGHT = 85 // % of view height

export const getFullVideoViewHeight = (deviceSize: string) => {
  const h = {
    xs: 35,
    sm: 40,
    md: 60,
    lg: 85,
    xl: 85,
  }[deviceSize]

  return h ?? FULL_VIDEO_VIEW_HEIGHT
}

export const getVideoPlayerOptions = ({
  autoplay = false,
  aspectRatio = '16:9',
  muted = false,
}): VideoPlayerOptions => {
  return {
    autoplay,
    muted,
    aspectRatio,
    responsive: true,
    controls: true,
    playback_rates: [0.5, 1, 1.5, 2],
    skip_buttons: {
      forward: 10,
      backward: 10,
    },
  }
}
